import {
  GET_ALL_USERS,
  GET_ALL_USERS_ERROR,
  GET_CERTAIN_USER,
  GET_CERTAIN_USER_ERROR,
  GET_COUNT_ALL_USERS,
  GET_COUNT_ALL_USERS_ERROR,
  UPDATE_CERTAIN_USER,
  UPDATE_CERTAIN_USER_ERROR,
  DELETE_CERTAIN_USER,
  DELETE_CERTAIN_USER_ERROR
} from "../types";

const initialState = {};

export const allUsersReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_USERS:
      return { ...state, allUsers: action.payload };
    case GET_ALL_USERS_ERROR:
      return { ...state, allUsersError: action.payload };
    case GET_CERTAIN_USER:
      return { ...state, certainUser: action.payload };
    case GET_CERTAIN_USER_ERROR:
      return { ...state, certainUserError: action.payload };
    case UPDATE_CERTAIN_USER:
      return {
        ...state,
        status: action.payload.status,
        updateMessage: action.payload.message
      };
    case UPDATE_CERTAIN_USER_ERROR:
      return {
        ...state,
        status: action.payload.status,
        updateMessage: action.payload.message
      };
    case DELETE_CERTAIN_USER:
      return {
        ...state,
        status: action.payload.status,
        updateMessage: action.payload.message
      };
    case DELETE_CERTAIN_USER_ERROR:
      return {
        ...state,
        status: action.payload.status,
        updateMessage: action.payload.message
      };
    case GET_COUNT_ALL_USERS:
      return { ...state, allUsersNumber: action.payload };
    case GET_COUNT_ALL_USERS_ERROR:
      return { ...state, allUsersNumberError: action.payload };

    default:
      return state;
  }
};
